import type { ObjectDirective } from 'vue';

const hover: ObjectDirective<HTMLElement, (val: boolean) => void> = {
  mounted(el, binding) {
    const onEnter = () => binding.value?.(true);
    const onLeave = () => binding.value?.(false);

    (el as any)._hoverHandlers = { onEnter, onLeave };

    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);
  },

  beforeUnmount(el) {
    const handlers = (el as any)._hoverHandlers;
    if (handlers) {
      el.removeEventListener('mouseenter', handlers.onEnter);
      el.removeEventListener('mouseleave', handlers.onLeave);
    }
  },
};

export default hover;
